import { HttpErrorResponse } from "@angular/common/http";
import { createAction, props } from "@ngrx/store";
import { TripData, TripVersionHistoryData } from "../../../models";

export const tripSearchVersionRequest = createAction(
        '[Trip] Trip search version request', props<{ trip: TripData }>());

export const tripSearchVersionFail = createAction(
        '[Trip] Trip search version fail', props<{ httpErrorData: HttpErrorResponse, translatedHeaderMessage: string }>());

export const tripSearchVersionSuccess = createAction(
        '[Trip] Trip search version success', props<{ searchResult: TripVersionHistoryData[] }>());

export const tripClearVersionHistory = createAction(
        '[Trip] Trip clear version history');